import { render, staticRenderFns } from "./big_package.vue?vue&type=template&id=1c9b2613&scoped=true&"
import script from "./big_package.vue?vue&type=script&lang=js&"
export * from "./big_package.vue?vue&type=script&lang=js&"
import style0 from "./big_package.vue?vue&type=style&index=0&id=1c9b2613&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9b2613",
  null
  
)

export default component.exports